import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";

import Dashboard from "./pages/Dashboard";
import DeliveryPartners from "./pages/DeliveryPartners";
import RiderDetailPage from "./pages/DeliveryPartners/RiderDetailPage";
import Transactions from "./pages/Transactions";
import CashCOD from "./pages/CashCOD";
import PayrollExpenses from "./pages/PayrollExpenses";
import Payouts from "./pages/Payouts";
import UsersLeaves from "./pages/UsersLeaves";
import Accounts from "./pages/Accounts";
import Communications from "./pages/Communications";
import Settings from "./pages/Settings";
import SettingsSectionRouter from "./pages/Settings/SectionRouter";

const routes = [
  // Auth (public)
  {
    path: "/login",
    component: Login,
    routeType: "public",
    isAuthPage: true,
    layout: "auth",
    title: "Login",
  },
  {
    path: "/forgot-password",
    component: ForgotPassword,
    routeType: "public",
    isAuthPage: true,
    layout: "auth",
    title: "Forgot Password",
  },
  {
    path: "/reset-password",
    component: ResetPassword,
    routeType: "public",
    isAuthPage: true,
    layout: "auth",
    title: "Reset Password",
  },

  // Modules (private)
  {
    path: "/dashboard",
    component: Dashboard,
    routeType: "private",
    layout: "dashboard",
    title: "Dashboard",
    module: "dashboard",
  },
  {
    path: "/delivery-partners",
    component: DeliveryPartners,
    routeType: "private",
    layout: "dashboard",
    title: "Delivery Partners",
    module: "deliveryPartners",
  },
  {
    path: "/delivery-partners/:id",
    component: RiderDetailPage,
    routeType: "private",
    layout: "dashboard",
    title: "Rider Details",
    module: "deliveryPartners",
  },
  {
    path: "/transactions",
    component: Transactions,
    routeType: "private",
    layout: "dashboard",
    title: "Transactions",
    module: "transactions",
  },
  {
    path: "/cash-cod",
    component: CashCOD,
    routeType: "private",
    layout: "dashboard",
    title: "Cash & COD",
    module: "cashCOD",
  },
  {
    path: "/payroll-expenses",
    component: PayrollExpenses,
    routeType: "private",
    layout: "dashboard",
    title: "Payroll & Expenses",
    module: "payrollExpenses",
  },
  {
    path: "/payouts",
    component: Payouts,
    routeType: "private",
    layout: "dashboard",
    title: "Payouts",
    module: "payouts",
  },
  {
    path: "/users-leaves",
    component: UsersLeaves,
    routeType: "private",
    layout: "dashboard",
    title: "Users & Leaves",
    module: "usersLeaves",
  },
  {
    path: "/accounts",
    component: Accounts,
    routeType: "private",
    layout: "dashboard",
    title: "Accounts",
    module: "accounts",
  },
  {
    path: "/communications",
    component: Communications,
    routeType: "private",
    layout: "dashboard",
    title: "Communications",
    module: "communications",
  },
  {
    path: "/settings",
    component: Settings,
    routeType: "private",
    layout: "dashboard",
    title: "Settings",
    module: "settings",
  },
  {
    path: "/settings/:section",
    component: SettingsSectionRouter,
    routeType: "private",
    layout: "dashboard",
    title: "Settings",
    module: "settings",
  },
];

export default routes;